module.exports = __webpack_public_path__ + "d05514aefd7b6121ebb184e882b44a66.svg";